import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { themes } from 'themes';
import { useNavigate } from 'react-router-dom';

export const ChooseTheme = () => {
  const [selectedTheme, setSelectedTheme] = useState(
    Cookies.get('wire24_theme') || 'glass'
  );

  const navigate = useNavigate();

  // Apply theme to <body> whenever theme changes
  useEffect(() => {
    const themeConfig = themes[selectedTheme];
    document.body.className = `${themeConfig.colors.background} transition-all duration-500`;
    Cookies.set('wire24_theme', selectedTheme, { expires: 365 });
  }, [selectedTheme]);

  const handleContinue = () => {
    navigate('/app');
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-8 px-6 text-center">
      <div className="">
        <h1 className="text-2xl text-white font-semibold">Choose Your Theme</h1>
        <p className="text-gray-300">
          Select a theme to preview how your admin dashboard will look.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {Object.entries(themes).map(([key, theme]) => (
          <button
            key={key}
            onClick={() => setSelectedTheme(key)}
            className={`p-6 w-64 h-40 flex flex-col justify-center items-center cursor-pointer transition-transform transform hover:scale-105 ${
              theme.className
            } ${selectedTheme === key ? 'ring-4 ring-white' : ''}`}
          >
            <span className="text-lg font-bold">{theme.name}</span>
            <span className="text-xs mt-2">Preview</span>
          </button>
        ))}
      </div>

      <button
        onClick={handleContinue}
        className={`px-6 py-3 rounded-lg font-medium transition ${themes[selectedTheme].colors.button}`}
      >
        Continue with {themes[selectedTheme].name}
      </button>
    </div>
  );
};
